/**
 * GitLab REST API must target the GitLab host (gitlab.com or self‑hosted).
 * When `authUrl` is missing or blank, `??` / template coercion would yield a
 * path-only URL and the browser resolves it against the Next.js origin.
 */
export function resolveGitlabBaseUrl(authUrl?: string | null): string {
  const trimmed = authUrl?.trim();
  if (!trimmed) return 'https://gitlab.com';
  return trimmed.replace(/\/$/, '');
}
